import { type HUImageDraft } from "@modules/dtos/imageDto"
import { type HUImage } from "@modules/types/imageTypes"
import * as Yup from "yup"

export function getAvatartValidationSchema() {
  return Yup.object({
    avatar: Yup.mixed(),
  })
}

export const convertUserAvatarToFormik = (avatar?: HUImage): HUImageDraft => {
  return {
    serverBlurHash: avatar?.hash ?? "",
    serverPath: avatar?.url ?? "",
    localPath: undefined,
    localBase64: undefined,
  }
}
